import { Component, inject } from '@angular/core';
import { AuthStore } from '@core/store/core/auth.store';
import { ButtonComponent } from '@mmscan/design-system';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, PrimeIcons } from 'primeng/api';

@Component({
  selector: 'mp-logout-button',
  imports: [ButtonComponent],
  templateUrl: './logout-button.component.html',
})
export class LogoutButtonComponent {
  protected authStore = inject(AuthStore);
  private confirmationService = inject(ConfirmationService);
  private translate = inject(TranslateService);

  protected primeIcons = PrimeIcons;

  onLogout(): void {
    this.confirmationService.confirm({
      message: this.translate.instant('nav.settings.logoutConfirmMessage'),
      header: this.translate.instant('nav.settings.logoutConfirmHeader'),
      icon: PrimeIcons.EXCLAMATION_CIRCLE,
      rejectButtonProps: {
        label: this.translate.instant('common.actions.cancel'),
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: this.translate.instant('nav.settings.logoutConfirmAccept'),
      },
      accept: () => this.authStore.logout(),
    });
  }
}
